"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _label = require("./label.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FormLabel = /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_label.FormLabelStyled, _extends({
    ref: ref
  }, props), props.children);
}));

exports.FormLabel = FormLabel;
FormLabel.defaultProps = {
  measure: 'sm',
  as: 'label'
};
FormLabel.displayName = 'FormLabel';
FormLabel.Style = _label.FormLabelStyled;